import * as yup from 'yup'

const requiresAdvanceNotificationFields = (enableAdvance, renewable) =>
  enableAdvance && !renewable

const schema = yup.object().shape({
  name: yup.string().required('Nome é obrigatório'),
  price: yup.string().required('Valor é obrigatório'),
  renewable: yup.boolean(),
  enableAdvance: yup.boolean(),
  endDate: yup
    .date()
    .nullable()
    .when(['enableAdvance', 'renewable'], {
      is: requiresAdvanceNotificationFields,
      then: yup
        .date()
        .required('Término é obrigatório')
        .typeError('Confirme uma data'),
    }),
  valueAdvance: yup
    .number()
    .transform((value) => (Number.isNaN(value) ? null : value))
    .nullable()
    .when(['enableAdvance', 'renewable'], {
      is: requiresAdvanceNotificationFields,
      then: yup
        .number()
        .required('Antecedência é obrigatória')
        .typeError('Confirme um valor'),
    }),
  periodAdvance: yup.string().when(['enableAdvance', 'renewable'], {
    is: requiresAdvanceNotificationFields,
    then: yup.string().required('Período é obrigatório'),
  }),
  frequencyAdvance: yup.string().when(['enableAdvance', 'renewable'], {
    is: requiresAdvanceNotificationFields,
    then: yup.string().required('Frequência dos disparos é obrigatória'),
  }),
})

export default schema
